import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

export const correlationsKey = 'correlations';

export const correlationsAdapter = createEntityAdapter<ICorrelation>({
  selectId: correlation => correlation.id,
  sortComparer: false,
});

export interface ICorrelationsRequestState {
  projectId: string;
  areaId?: string;
  date?: string;
  detailed?: boolean;
}

export interface ICorrelationsState extends EntityState<ICorrelation> {
  loaded: boolean;
  loading: boolean;
  triggerId: string | null;
  request: ICorrelationsRequestState | null;
  error: IApiBaseErrorResponse | null;
}

export const initialState: ICorrelationsState = correlationsAdapter.getInitialState({
  loaded: false,
  loading: false,
  triggerId: null,
  request: null,
  error: null,
});
